import React from 'react';
import styled from 'styled-components';
import Button from '../../common/Button.js';
import { Link } from 'react-router-dom';

const CTAWrapper = styled.section`
  background-image: linear-gradient(rgba(44, 62, 80, 0.9), rgba(44, 62, 80, 0.9)), url('/images/cta-bg.png');
  background-size: cover;
  background-position: center;
  padding: 6rem 0;
  color: var(--white);
  text-align: center;
`;

const CTAContent = styled.div`
  max-width: 800px;
  margin: 0 auto;
  
  h2 {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  }
  
  p {
    font-size: 1.125rem;
    margin-bottom: 2.5rem;
    opacity: 0.9;
  }
  
  .buttons {
    display: flex;
    gap: 1rem;
    justify-content: center;
    
    @media (max-width: 576px) {
      flex-direction: column;
      gap: 0.5rem;
    }
  }
`;

const CTASection = () => {
  return (
    <CTAWrapper>
      <div className="container">
        <CTAContent>
          <h2>Ready to Find Your Dream Home?</h2>
          <p>
            Whether you're looking to buy a new home, rent a property, or develop land,
            Shoffner Homes is here to help you every step of the way.
          </p>
          <div className="buttons">
            <Button as={Link} to="/contact" variant="secondary" size="large">
              Contact Us Today
            </Button>
            <Button 
              as={Link} 
              to="/homes-for-sale" 
              variant="outline" 
              size="large"
              style={{ 
                color: 'white', 
                borderColor: 'white', 
                borderWidth: '3px',
                textShadow: '0 1px 3px rgba(0,0,0,0.5)'
              }}
            >
              View Available Homes
            </Button>
          </div>
        </CTAContent>
      </div>
    </CTAWrapper>
  );
};

export default CTASection;